import { EXTENSION_CHROME_STORE_URL } from "@prostocheck/shared";

import { TExtensionBrowser } from "./use-extension-store.models";

/**
 * `bowser`'s lower-cased browser name (`getBrowserName(true)`) → the browser
 * we ship a store listing for. Only browsers we publish for appear; every
 * other browser (and Node, bots, in-app webviews) falls through to "not
 * available for your browser" on the /extension guide. Edge and Opera are
 * Chromium and could be pointed at the Chrome Web Store here once we decide to.
 */
export const EXTENSION_BROWSER_BY_UA_NAME: Record<
  string,
  TExtensionBrowser | undefined
> = {
  chrome: "chrome",
};

/**
 * Where each published browser's store listing lives. Keyed by every
 * `TExtensionBrowser`, so a new member forces an entry. `undefined` until
 * that browser's env var is set — see `EXTENSION_CHROME_STORE_URL`.
 */
export const EXTENSION_STORE_URL_BY_BROWSER: Record<
  TExtensionBrowser,
  string | undefined
> = {
  chrome: EXTENSION_CHROME_STORE_URL,
};
